module.exports = __webpack_public_path__ + "static/media/EllipsisBlue.06cb1c14.svg";